
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance-articles/[slug]",
      function () {
        return require("private-next-pages/travel-insurance-articles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-insurance-articles/[slug]"])
      });
    }
  